import { render, staticRenderFns } from "./LabelCountData.vue?vue&type=template&id=7219d1df&scoped=true"
import script from "./LabelCountData.vue?vue&type=script&lang=js"
export * from "./LabelCountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7219d1df",
  null
  
)

export default component.exports